<template>
  <div class="container">
    <LineChart
      v-if="loaded"
      :chartdata="chartdata"
      :options="options"
      :styles="myStyles"
    /> 
    <!-- ADD v-if="loaded" for Chart with API data -->
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'

export default {
  name: 'UnitSalesChartContainer',
  components: { LineChart },
   data() {
   return {
    loaded: true, 
    chartdata: {
      labels: ['January', 'February', 'March', 'April', 'May', 'June'],
      datasets: [
        {
          label: 'UnitName',
          data: [100, 150, 220, 250, 300, 350],
          backgroundColor: "transparent",
          borderColor: "rgba(1, 116, 188, 0.50)",
          pointBackgroundColor: "rgba(171, 71, 188, 1)"
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false
    }
   }
   },
   computed: {
    myStyles () {
      return {
        height: `450px`,
        position: 'relative'
      }
    }
  }

  // -------------------- Chart with API data --------------------- //

//   data: () => ({
//     loaded: false,
//     chartdata: null
//   }),
//   async mounted () {
//     this.loaded = false
//     try {
//       const { userlist } = await fetch('/api/userlist')
//       this.chartdata = userlist
//       this.loaded = true
//     } catch (e) {
//       console.error(e)
//     }
//   }
}
</script>